import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { PopupService } from '@popup';
import { Router } from '@angular/router';
import { TokenService } from '@token';
import { Observable, EMPTY } from 'rxjs';
// import { environment } from '@environment';
import { tap } from 'rxjs/operators';
import { MESSAGES } from 'src/app/constants/message.constants';
import { environment } from '@environment';
import { NOT_FOUND_ROUTE } from 'src/app/modules/public/constants';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(
    private $router: Router,
    private $popup: PopupService,
    private $token: TokenService,
  ) {}

  // intercept all http requests
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // check internet connectivity
    if (!navigator.onLine) {
      this.$popup.open(MESSAGES.OFFLINE, 'ERROR', {duration: 4000});
      return EMPTY;
    }
    // const isApiUrl = req.url.charAt(0) === '~';
    return next.handle(req.clone({
      body: req.body,
      url: this.$parseUrl(req.url),
      headers: this.$parseHeader(req.headers)
    })).pipe(
      tap(event => {
        // request success
        // if (event instanceof HttpResponse) {
        //   if (event.status === 204) {
        //     this.$router.navigate(NOT_FOUND_ROUTE.url);
        //   }
        // }
      }, event => {
        if (event instanceof HttpErrorResponse) {
          let message = event.error.message || MESSAGES.ERROR.UNKNOWN;
          if (event.status === 504 || event.status === 0) {
            message = MESSAGES.ERROR.$504;
          } else if (event.status === 404) {
            this.$router.navigate(NOT_FOUND_ROUTE.url);
          }
          this.$popup.open(message, 'ERROR', {duration: 3000});
        }
      })
    );
  }
  private $parseUrl(url: string): string {
    if (url.charAt(0) === '~') {
      url = url.substr(1);
    } else {
      try {
        const urlSegment = new URL(url);
      } catch (err) {
        url = environment.url + url;
      }
    }
    return url;
  }
  private $parseHeader(headers: HttpHeaders): HttpHeaders {
    const token = this.$token.value || environment.publicToken;
    return headers.set('authorization', `Bearer ${token}`);
  }
}
